import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { EGiftDenomination } from 'src/app/shared/models/eGift/EGiftDenomination.model';
import { EGiftPromoCode } from 'src/app/shared/models/eGift/EGiftPromoCode.model';
import { EGiftVenue } from 'src/app/shared/models/eGift/EGiftVenue.model';

@Component({
	selector: 'app-e-gift-value-select',
	templateUrl: './e-gift-value-select.component.html',
	styleUrls: ['../../gift.style.scss'],
})
export class EGiftValueSelectComponent implements OnInit {
	@Input() eGiftVenue: EGiftVenue;
	@Output() selectedAmountOutput: EventEmitter<{
		amount: number;
		value: number;
	}> = new EventEmitter<{
		amount: number;
		value: number;
	}>();
	@Output() selectedPromoCode: EventEmitter<EGiftPromoCode> = new EventEmitter<EGiftPromoCode>();

	availableDenominations: EGiftDenomination[] = [];

	customAmount: boolean = false;

	promoCode: string;
	promoCodeSelected: EGiftPromoCode;

	moment: any = moment;

	selectedValue: EGiftDenomination;
	selectedAmount: number;

	constructor(private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.eGiftVenue.EGiftDenomination.forEach((i) => {
			if (i.prefix) {
				i.displayName = `${i.prefix || ''} $${i.value} for $${i.amount}`;
				i.sortVal = 1;
			} else {
				i.isCustomAmount = false;
				i.displayName = `$${i.value}`;
				i.sortVal = 0;
			}

			if (i.active) {
				if (!i.expirationDate) {
					this.availableDenominations.push(i);
				}
				if (i.expirationDate && moment(i.expirationDate).isAfter(moment())) {
					this.availableDenominations.push(i);
				}
			}
		});
		if (this.eGiftVenue.customAmount) {
			this.availableDenominations.push(
				new EGiftDenomination({
					venueKey: this.eGiftVenue.venueKey,
					displayName: 'Custom Amount',
					isCustomAmount: true,
					sortVal: 2,
				})
			);
		}

		this.denominationSort();
	}

	async checkPromoCode(promoCode: string) {
		try {
			const resp = await this.focuslink.eGiftPromoCodeGet(this.eGiftVenue.venueKey, promoCode);
			this.promoCodeSelected = new EGiftPromoCode(resp);
			this.selectedPromoCode.emit(this.promoCodeSelected);
		} catch (error) {}
	}

	selectOption(denom: EGiftDenomination) {
		this.selectedAmount = denom.value;
		if (denom.isCustomAmount) {
			this.customAmount = true;
		} else {
			this.customAmount = false;
		}
		this.selectedAmountOutput.emit({
			value: denom.value,
			amount: denom.amount,
		});
	}

	denominationSort() {
		this.availableDenominations.sort((a, b) => {
			if (a.sortVal === b.sortVal) {
				return a.value - b.value;
			} else {
				return a.sortVal < b.sortVal ? -1 : 1;
			}
		});
	}
}
